import { createFileRoute, redirect } from '@tanstack/react-router';

/** The proposals are a view of Oportunidades (spec 030 § 3): the old address lands there. */
export const Route = createFileRoute('/_app/proposals/')({
  beforeLoad: () => {
    throw redirect({ to: '/deals', search: { display: 'proposals' } as never, replace: true });
  },
});
